module.exports = __webpack_public_path__ + "img/ios-volume-off.287ed219.svg";